import { Record } from 'immutable';

export default class ContactRecord extends Record({
  id: null,
  role: undefined,
  customer: undefined,
  person: undefined,
  createdAt: undefined,
}) {
}
